/* eslint-disable no-undef */
import {
    checkIfValidQuantities,
    getTotalExtendedPrice,
    getTotalQuantity,
} from './eventHandlerUtil';
import { numFormatObj } from 'src/utils/util';
import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);
const invalidProductMsg = () =>
    t('productValidationMessages.invalidProductMsg');
const invalidBundleItemMsg = () =>
    t('productValidationMessages.invalidBundleItemMsg');
const invalidSPSitemMsg = () =>
    t('productValidationMessages.invalidSPSitemMsg');
const emptyBundleMsg = () => t('productValidationMessages.emptyBundleMsg');

export const getModifiedProcedureResponse = (procedureData) => {
    return Object.fromEntries(
        Object.entries(procedureData).map((entry) => [
            entry[0],
            entry[1] instanceof Array
                ? entry[1].map((x) => ({
                      ...x,
                      description:
                          x.description === 'MazorX Robot Used'
                              ? 'MazorX Robot Used'
                              : x.description,
                      isSelected: null,
                      isMedtronicSelected: null,
                      isCompetitiveSelected: null,
                  }))
                : entry[1],
        ])
    );
};

export const getModifiedBundleChildItems = (
    existingItem,
    pricedItemsArr,
    bundleHeadersArr
) => {
    return existingItem.children.map((child) => {
        let updatedChildItemObj = { ...child };
        const pricedChildItemIdx = pricedItemsArr
            .map((x) => x.productCFN)
            .findIndex((y) => y === child.cfn);
        if (pricedChildItemIdx >= 0) {
            updatedChildItemObj = {
                ...pricedItemsArr[pricedChildItemIdx],
                cfn: child.cfn,
                lotSerial: child.lotSerial,
                salesOrg: pricedItemsArr[pricedChildItemIdx].salesOrg,
            };
            updatedChildItemObj.basePrice = null;
            if (pricedItemsArr[pricedChildItemIdx].salesOrg === 'S030') {
                updatedChildItemObj.isInvalidItemMsg =
                    'Tissue items can\'t be added as bundled item.';
            } else if (
                pricedItemsArr[pricedChildItemIdx].exclusionStatus ===
                'Item number not found.'
            ) {
                updatedChildItemObj.isInvalidItemMsg = invalidProductMsg();
            } else if (pricedItemsArr[pricedChildItemIdx].exclusionStatus) {
                updatedChildItemObj.isInvalidItemMsg =
                    pricedItemsArr[pricedChildItemIdx].exclusionStatus;
            }
        } else if (bundleHeadersArr.includes(child.cfn)) {
            updatedChildItemObj.isInvalidItemMsg =
                'Bundle cannot be added as item.';
        } else if (child.cfn.startsWith('SPS')) {
            updatedItemObj.isInvalidItemMsg = invalidSPSitemMsg;
        } else {
            updatedChildItemObj.isInvalidItemMsg = invalidProductMsg();
        }
        return updatedChildItemObj;
    });
};

// export const getModifiedItemTableData = (
//     existingItemsArr,
//     pricedItemsArr,
//     bundleHeadersArr,
//     chkreportpayment
// ) => {
//     return existingItemsArr.map((existingItem) => {
//         let updatedItemObj = { ...existingItem };
//         if (
//             (chkreportpayment === true &&
//                 existingItem.cfn.toUpperCase().startsWith('M2')) ||
//             existingItem.cfn.toUpperCase().startsWith('M1') ||
//             existingItem.cfn.toUpperCase().startsWith('BUN') ||
//             existingItem.cfn.toUpperCase().startsWith('KEN')
//         ) {
//             updatedItemObj.isInvalidItemMsg = 'Bundle items cannot be added';
//         } else {
//             const pricedItemIdx = pricedItemsArr
//                 .map((x) => x.productCFN)
//                 .findIndex((y) => y === existingItem.cfn);
//             if (pricedItemIdx >= 0) {
//                 updatedItemObj = {
//                     ...pricedItemsArr[pricedItemIdx],
//                     cfn: existingItem.cfn,
//                     lotSerial:
//                         pricedItemsArr[pricedItemIdx].salesOrg === 'S030'
//                             ? [{ used: true }]
//                             : existingItem.lotSerial,
//                     accountOwned: existingItem.accountOwned
//                         ? existingItem.accountOwned
//                         : false,
//                     salesOrg: pricedItemsArr[pricedItemIdx].salesOrg,
//                 };
//                 if (existingItem.isBundleItem) {
//                     updatedItemObj.isBundleItem = existingItem.isBundleItem;
//                     updatedItemObj.children = existingItem.children;
//                 }
//                 updatedItemObj.extPrice = getTotalExtendedPrice(
//                     pricedItemsArr[pricedItemIdx].basePrice
//                         ? pricedItemsArr[pricedItemIdx].basePrice
//                         : '',
//                     updatedItemObj.lotSerial,
//                     'total'
//                 );
//                 if (
//                     bundleHeadersArr &&
//                     bundleHeadersArr.includes(existingItem.cfn)
//                 ) {
//                     if (
//                         existingItem.children &&
//                         existingItem.children.length > 0
//                     ) {
//                         // bundle child items validation
//                         updatedItemObj.children = getModifiedBundleChildItems(
//                             existingItem,
//                             pricedItemsArr,
//                             bundleHeadersArr
//                         );
//                     } else {
//                         updatedItemObj.lotSerial = existingItem.lotSerial.map(
//                             (x) => ({
//                                 ...x,
//                                 isInvalidQtyMsg: emptyBundleMsg,
//                             })
//                         );
//                     }
//                 } else if (
//                     pricedItemsArr[pricedItemIdx].exclusionStatus ===
//                     'Item number not found.'
//                 ) {
//                     updatedItemObj.isInvalidItemMsg = invalidProductMsg;
//                 } else {
//                     updatedItemObj.isInvalidItemMsg = null;
//                 }
//             } else if (existingItem.cfn.startsWith('SPS')) {
//                 updatedItemObj.isInvalidItemMsg = invalidSPSitemMsg;
//             } else if (
//                 bundleHeadersArr &&
//                 bundleHeadersArr.includes(existingItem.cfn) &&
//                 existingItem.cfn.startsWith('M1')
//             ) {
//                 updatedItemObj.isInvalidItemMsg = invalidBundleItemMsg;
//             } else {
//                 updatedItemObj.isInvalidItemMsg = invalidProductMsg;
//             }
//         }
//         return updatedItemObj;
//     });
// };

export const getModifiedItemTableData = (
    existingItemsArr,
    pricedItemsArr,
    bundleHeadersArr,
    isFromReportPaymentScreen,
    deliveredUnidRodItems
) => {
    const itemTableDataWithPrices = existingItemsArr.map((existingItem) => {
        let updatedItemObj = { ...existingItem };
        if (
            isFromReportPaymentScreen &&
            existingItem.isAdditionalCartEntry &&
            (existingItem.cfn.toUpperCase().startsWith('M2') ||
                existingItem.cfn.toUpperCase().startsWith('M1') ||
                existingItem.cfn.toUpperCase().startsWith('BUN') ||
                existingItem.cfn.toUpperCase().startsWith('KEN')) &&
            bundleHeadersArr.includes(existingItem.cfn.toUpperCase())
        ) {
            updatedItemObj.isInvalidItemMsg = 'Bundle items cannot be added';
        } else {
            const pricedItemIdx = pricedItemsArr
                .map((x) => x.productCFN)
                .findIndex((y) => y === existingItem.cfn);
            const unidItem = deliveredUnidRodItems?.filter(
                (uItem) =>
                    uItem.productCFN === existingItem.cfn &&
                    uItem.isUnidRodItem &&
                    uItem.itemBatchAndQty &&
                    uItem.itemBatchAndQty.length > 0
            );
            if (pricedItemIdx >= 0) {
                if (
                    isFromReportPaymentScreen &&
                    existingItem.isAdditionalCartEntry
                ) {
                    updatedItemObj = {
                        ...pricedItemsArr[pricedItemIdx],
                        cfn: existingItem.cfn,
                        lotSerialNumber: existingItem.lotSerialNumber
                            ? existingItem.lotSerialNumber
                            : '',
                        accountOwned: existingItem.accountOwned
                            ? existingItem.accountOwned
                            : false,

                        salesOrg: pricedItemsArr[pricedItemIdx].salesOrg,
                        unitPrice: pricedItemsArr[pricedItemIdx].basePrice,
                        usedQuantity:
                            pricedItemsArr[pricedItemIdx].salesOrg === 'S030'
                                ? existingItem.usedQuantity
                                : existingItem.usedQuantity === true ||
                                  parseInt(existingItem.usedQuantity) > 0,
                        otherQuantity:
                            pricedItemsArr[pricedItemIdx].salesOrg === 'S030'
                                ? existingItem.otherQuantity === true ||
                                  (parseInt(existingItem.usedQuantity) > 0
                                      ? false
                                      : parseInt(existingItem.otherQuantity) >
                                        0)
                                : existingItem.otherQuantity,
                        isAdditionalCartEntry:
                            existingItem.isAdditionalCartEntry,
                    };
                    if (existingItem.isUnidRodItem || unidItem?.length > 0) {
                        updatedItemObj.isUnidRodItem = true;
                        updatedItemObj.batchQtyObjArr =
                            existingItem.batchQtyObjArr ||
                            (unidItem && unidItem[0]?.itemBatchAndQty);
                        if (existingItem.isInvalidUnidItemQuantity) {
                            updatedItemObj.isInvalidUnidItemQuantity =
                                existingItem.isInvalidUnidItemQuantity;
                        }
                    }

                    if (existingItem.adjustedUsedQtyPrice) {
                        updatedItemObj.adjustedUsedQtyPrice =
                            existingItem.adjustedUsedQtyPrice;
                    }
                    if (existingItem.isInvalidQtyMsg) {
                        updatedItemObj.isInvalidQtyMsg =
                            existingItem.isInvalidQtyMsg;
                    }
                    if (existingItem.isInvalidLotSerialMsg) {
                        updatedItemObj.isInvalidLotSerialMsg =
                            existingItem.isInvalidLotSerialMsg;
                    }

                    //cannot have both the value in object
                    if (existingItem.isAdditionalCartEntry) {
                        delete updatedItemObj.otherQuantity;
                    }

                    if (pricedItemsArr[pricedItemIdx].exclusionStatus) {
                        updatedItemObj.isInvalidItemMsg =
                            pricedItemsArr[pricedItemIdx].exclusionStatus ===
                            'Item number not found.'
                                ? invalidProductMsg()
                                : pricedItemsArr[pricedItemIdx].exclusionStatus;
                    }
                    if (existingItem.payment) {
                        updatedItemObj.payment = existingItem.payment;
                    }
                } else if (
                    isFromReportPaymentScreen &&
                    !existingItem.isAdditionalCartEntry
                ) {
                    return existingItem;
                } else {
                    updatedItemObj = {
                        ...pricedItemsArr[pricedItemIdx],
                        cfn: existingItem.cfn,
                        lotSerial:
                            pricedItemsArr[pricedItemIdx].salesOrg === 'S002'
                                ? existingItem.lotSerial.map((lotItem) => ({
                                      ...lotItem,
                                      used:
                                          lotItem.used === true ||
                                          parseInt(lotItem.used) > 0,
                                      other:
                                          lotItem.other === true ||
                                          (parseInt(lotItem.used) > 0
                                              ? false
                                              : parseInt(lotItem.other) > 0),
                                  }))
                                : existingItem.lotSerial,
                        accountOwned: existingItem.accountOwned
                            ? existingItem.accountOwned
                            : false,
                        salesOrg: pricedItemsArr[pricedItemIdx].salesOrg,
                        isAdditionalCartEntry:
                            existingItem?.isAdditionalCartEntry
                                ? existingItem.isAdditionalCartEntry
                                : false,
                        isBundleExpanded: existingItem.isBundleExpanded,
                    };
                    if (existingItem.payment) {
                        updatedItemObj.payment = existingItem.payment;
                    }
                    if (existingItem.isUnidRodItem || unidItem?.length > 0) {
                        updatedItemObj.isUnidRodItem = true;
                        updatedItemObj.batchQtyObjArr =
                            existingItem.batchQtyObjArr ||
                            (unidItem && unidItem[0]?.itemBatchAndQty);
                        if (existingItem.isInvalidUnidItemQuantity) {
                            updatedItemObj.isInvalidUnidItemQuantity =
                                existingItem.isInvalidUnidItemQuantity;
                        }
                    }

                    if (existingItem.isBundleItem) {
                        updatedItemObj.isBundleItem = existingItem.isBundleItem;
                        updatedItemObj.children = existingItem.children;
                    }

                    if (pricedItemsArr[pricedItemIdx].exclusionStatus) {
                        updatedItemObj.isInvalidItemMsg =
                            pricedItemsArr[pricedItemIdx].exclusionStatus ===
                            'Item number not found.'
                                ? invalidProductMsg()
                                : pricedItemsArr[pricedItemIdx].exclusionStatus;
                    } else {
                        updatedItemObj.isInvalidItemMsg = null;
                        if (
                            bundleHeadersArr &&
                            bundleHeadersArr.includes(
                                existingItem.cfn.toUpperCase()
                            )
                        ) {
                            if (
                                existingItem.children &&
                                existingItem.children.length > 0
                            ) {
                                // bundle child items validation
                                updatedItemObj.children =
                                    getModifiedBundleChildItems(
                                        existingItem,
                                        pricedItemsArr,
                                        bundleHeadersArr
                                    );
                            } else {
                                updatedItemObj.noItemInBundleErr =
                                    emptyBundleMsg;
                            }
                        }
                        if (existingItem.adjustedUsedQtyPrice) {
                            updatedItemObj.adjustedUsedQtyPrice =
                                existingItem.adjustedUsedQtyPrice;
                        }
                        if (existingItem.adjustedOtherQtyPrice) {
                            updatedItemObj.adjustedOtherQtyPrice =
                                existingItem.adjustedOtherQtyPrice;
                        }
                        updatedItemObj.extPrice = getTotalExtendedPrice(
                            pricedItemsArr[pricedItemIdx].basePrice
                                ? pricedItemsArr[pricedItemIdx].basePrice
                                : '',
                            updatedItemObj.lotSerial,
                            'total'
                        );
                        updatedItemObj.otherQtyExtPrice = getTotalExtendedPrice(
                            pricedItemsArr[pricedItemIdx].basePrice
                                ? pricedItemsArr[pricedItemIdx].basePrice
                                : '',
                            updatedItemObj.lotSerial,
                            'other'
                        );
                        updatedItemObj.usedQtyExtPrice = getTotalExtendedPrice(
                            pricedItemsArr[pricedItemIdx].basePrice
                                ? pricedItemsArr[pricedItemIdx].basePrice
                                : '',
                            updatedItemObj.lotSerial,
                            'used'
                        );
                    }
                }
                if (existingItem.isLotSerialReqd) {
                    updatedItemObj.isLotSerialReqd =
                        existingItem.isLotSerialReqd;
                }
            } else if (existingItem.cfn.toUpperCase().startsWith('SPS')) {
                updatedItemObj.isInvalidItemMsg = invalidSPSitemMsg;
            } else if (
                bundleHeadersArr &&
                bundleHeadersArr.includes(existingItem.cfn) &&
                existingItem.cfn.toUpperCase().startsWith('M1')
            ) {
                updatedItemObj.isInvalidItemMsg = invalidBundleItemMsg;
            } else {
                updatedItemObj.isInvalidItemMsg = invalidProductMsg();
            }
        }
        return updatedItemObj;
    });

    if (
        itemTableDataWithPrices?.length > 0 &&
        itemTableDataWithPrices.some(
            (item) => item.isSerialRequired && !item.isLot
        )
    ) {
        itemTableDataWithPrices.forEach((item, itemIdx) => {
            const itemLotSerialArr = isFromReportPaymentScreen
                ? itemTableDataWithPrices
                      .filter((rpItem) => rpItem.productCFN === item.productCFN)
                      .map((rpItem) => rpItem.lotSerialNumber)
                : flattenLotSerialArrayOfArrays(
                      'serialIssued',
                      itemTableDataWithPrices,
                      item.cfn
                  );
            if (itemLotSerialArr?.length > 0) {
                let areDuplicateSerialNumbersPresent = false,
                    firstSerialIdxInItemArr = -1;
                if (isFromReportPaymentScreen) {
                    areDuplicateSerialNumbersPresent =
                        itemLotSerialArr.filter(
                            (x) => x === item.lotSerialNumber
                        )?.length > 1;
                    firstSerialIdxInItemArr = itemTableDataWithPrices.findIndex(
                        (y) =>
                            y.productCFN === item.productCFN &&
                            y.lotSerialNumber === item.lotSerialNumber
                    );
                    itemTableDataWithPrices[itemIdx].isInvalidLotSerialMsg =
                        areDuplicateSerialNumbersPresent &&
                        item.lotSerialNumber?.length > 0 &&
                        itemLotSerialArr.includes(item.lotSerialNumber) &&
                        firstSerialIdxInItemArr !== itemIdx
                            ? productIssueErrMsg
                            : itemTableDataWithPrices[itemIdx]
                                  .isInvalidLotSerialMsg;
                } else {
                    const serialNumArr = itemLotSerialArr.map((x) => x.Serial);
                    firstSerialIdxInItemArr = itemTableDataWithPrices.findIndex(
                        (data) =>
                            data.lotSerial.find(
                                (x) => x.id === itemLotSerialArr[0]?.id
                            )
                    );
                    itemTableDataWithPrices[itemIdx].lotSerial =
                        item.lotSerial.map((serObj, serIdx) => {
                            areDuplicateSerialNumbersPresent =
                                serialNumArr.filter((x) => x === serObj.Serial)
                                    ?.length > 1;
                            const firstSerialIdxInSerialArr =
                                item.lotSerial.filter(
                                    (x) => x.Serial === serObj.Serial
                                )?.length > 1
                                    ? item.lotSerial.findIndex(
                                          (y) => y.Serial === serObj.Serial
                                      )
                                    : -1;
                            return {
                                ...serObj,
                                isInvalidLotSerialMsg:
                                    areDuplicateSerialNumbersPresent &&
                                    (itemIdx !== firstSerialIdxInItemArr ||
                                        (itemIdx === firstSerialIdxInItemArr &&
                                            firstSerialIdxInSerialArr >= 0 &&
                                            serIdx !==
                                                firstSerialIdxInSerialArr)) &&
                                    item.isSerialRequired &&
                                    !item.isLot &&
                                    serObj.Serial?.length > 0 &&
                                    serialNumArr.includes(serObj.Serial)
                                        ? productIssueErrMsg
                                        : serObj.isInvalidLotSerialMsg,
                            };
                        });
                }
            }
        });
    }

    return itemTableDataWithPrices;
};
export const getPriceInNumberDataType = (price) => {
    if (typeof price === 'number') {
        return parseFloat(price);
    }
    if (price) {
        const symbolRemovedPrice = price.replaceAll(/[^\d.,]/g, '');
        const seperators = price.match(/[.,]/g) || [];
        
        let decimalSeperator = '';
        let thousandSeperator = '';
        
        // Check if currency has no decimal places (e.g., JPY, KRW)
        if (numFormatObj.minimumFractionDigits === 0) {
            // For zero-decimal currencies, we need to distinguish between:
            // - Thousands separators: exactly 3 digits after (e.g., "122,845" or "1,234,567")
            // - Decimal separators: 1-2 digits after (e.g., "122845.00") - should be truncated
            if (seperators.length > 0) {
                const lastSeparator = seperators[seperators.length - 1];
                const lastSeparatorIndex = symbolRemovedPrice.lastIndexOf(lastSeparator);
                const digitsAfterLastSeparator = symbolRemovedPrice.substring(lastSeparatorIndex + 1);
                
                // If exactly 3 digits after last separator, it's a thousands separator
                // If 1-2 digits after, it's likely a decimal that should be truncated
                if (digitsAfterLastSeparator.length === 3) {
                    // This is a thousands separator (e.g., "122,845" -> 122845)
                    thousandSeperator = lastSeparator;
                } else if (digitsAfterLastSeparator.length >= 1 && digitsAfterLastSeparator.length <= 2) {
                    // This is a decimal separator (e.g., "122845.00" -> 122845)
                    decimalSeperator = lastSeparator;
                    thousandSeperator = seperators.length > 1 ? seperators[0] : '';
                } else {
                    // All separators are thousands separators
                    thousandSeperator = seperators[0];
                }
            }
        } else if (seperators.length > 0) {
            // Last separator is decimal separator
            decimalSeperator = seperators.pop() || '';
            thousandSeperator = seperators.length > 0 ? seperators[0] : '';
        }

        let numString =
            decimalSeperator !== ''
                ? symbolRemovedPrice
                      .replaceAll(thousandSeperator, '')
                      .replace(decimalSeperator, '.')
                : symbolRemovedPrice.replaceAll(thousandSeperator, '');
        
        // For zero-decimal currencies, truncate any decimal portion
        if (numFormatObj.minimumFractionDigits === 0 && numString.includes('.')) {
            numString = Math.floor(parseFloat(numString)).toString();
        }
        
        return parseFloat(numString);
    }
};

export const getValidateItemsArr = (productsList) => {
    const bundleItems = productsList.filter(
        (item) => item.isBundleItem && item.children && item.children.length > 0
    );
    const bundleItemChildren =
        bundleItems && bundleItems.length > 0
            ? bundleItems.reduce((prev, curr) => prev.concat(curr.children), [])
            : [];
    const bundleChildrenQty = bundleItemChildren.map(
        (child) =>
            child.lotSerial &&
            child.lotSerial.map(
                (i) =>
                    (i.Other || i.other ? Number(i.Other || i.other) : 0) +
                    (i.Used || i.used ? Number(i.Used || i.used) : 0)
            )
    );
    const bundleChildrenLotSerial = bundleItemChildren.map(
        (child) => child.lotSerial && child.lotSerial.map((i) => i.Serial)
    );
    const arrProductCFN = productsList
        .map((item) => item.cfn)
        .concat(bundleItemChildren.map((x) => x.cfn));
    const arrLotSerialNumber = productsList
        .map((item) => item.lotSerial && item.lotSerial.map((i) => i.Serial))
        .concat(bundleChildrenLotSerial);
    const arrQuantity = productsList
        .map(
            (item) =>
                item.lotSerial &&
                item.lotSerial.map(
                    (i) =>
                        (i.Other || i.other ? Number(i.Other || i.other) : 0) +
                        (i.Used || i.used ? Number(i.Used || i.used) : 0)
                )
        )
        .concat(bundleChildrenQty);

    return arrProductCFN.map((cfn, i) => ({
        lotSerialNumber: arrLotSerialNumber[i].toString(),
        productCFN: cfn,
        quantity: arrQuantity[i].toString(),
    }));
};

export const getItemTableDataWithQtyValidation = (itemTableData) => {
    return itemTableData.map((item) => {
        let updatedChildrenArr;
        if (item.isBundleItem && item.children && item.children.length > 0) {
            updatedChildrenArr = item.children.map((child) => {
                const updatedChildLotSerialArr = child.lotSerial.map((x) => ({
                    ...x,
                    isInvalidQtyMsg: !checkIfValidQuantities(x)
                        ? t('productValidationMessages.mustEnterValidQty')
                        : null,
                }));
                return {
                    ...child,
                    lotSerial: updatedChildLotSerialArr,
                };
            });
        }
        const updatedLotSerialArr = item?.lotSerial?.map((x) => ({
            ...x,
            isInvalidQtyMsg:
                item?.isInvalidItemMsg !== null &&
                !item?.isInvalidItemMsg &&
                !checkIfValidQuantities(x)
                    ? item?.isBundleItem
                        ? t('productValidationMessages.mustEnterUsedQuantity')
                        : t('productValidationMessages.mustEnterValidQty')
                    : null,
        }));

        const itemObj = {
            ...item,
            lotSerial: updatedLotSerialArr,
        };
        if (item.isBundleItem) {
            if (updatedChildrenArr && updatedChildrenArr.length > 0)
                itemObj.children = updatedChildrenArr;
            else itemObj.noItemInBundleErr = emptyBundleMsg;
        }
        return itemObj;
    });
};

export const getValidatedBundleChildren = (
    existingChildren,
    validatedItems
) => {
    const validItemsCFN = validatedItems.map((x) => x.productCFN);
    return existingChildren.map((child) => {
        const isLotSerialReqd =
            (child.isLot || child.isSerialRequired) &&
            validatedItems.filter((val) => child.cfn === val.productCFN)
                .length > 0 &&
            validatedItems.filter(
                (val) =>
                    child.cfn ===
                    Object.prototype.hasOwnProperty.call(val.productCFN)[0],
                'lotSerialData'
            );
        const validatedLotSerialArr =
            isLotSerialReqd &&
            validatedItems.filter((val) => child.cfn === val.productCFN)[0]
                .lotSerialData;

        const updatedLotSerialArr = isLotSerialReqd
            ? child.lotSerial.map((x) =>
                  validatedLotSerialArr.find(
                      (vLot) =>
                          x.Serial &&
                          x.Serial.length > 0 &&
                          vLot.lotSerialNumber === x.Serial &&
                          vLot.statusCode === '10712'
                  )
                      ? {
                            ...x,
                            isInvalidLotSerialMsg: child.isLot
                                ? 'Invalid Lot Number'
                                : 'Invalid Serial Number',
                        }
                      : validatedLotSerialArr.find(
                            (vLot) =>
                                (!x.Serial ||
                                    (x.Serial && x.Serial.length === 0)) &&
                                vLot.statusCode === '10712'
                        )
                      ? {
                            ...x,
                            isInvalidLotSerialMsg: child.isLot
                                ? 'Lot number required'
                                : 'Serial number required',
                        }
                      : { ...x, isInvalidLotSerialMsg: null }
              )
            : child.lotSerial.map((x) => ({
                  ...x,
                  isInvalidLotSerialMsg: null,
              }));

        return {
            ...child,
            isInvalidItemMsg: !validItemsCFN.includes(child.cfn)
                ? invalidProductMsg()
                : null,
            isLotSerialReqd: isLotSerialReqd,
            lotSerial: updatedLotSerialArr,
        };
    });
};

export const getValidatedItemTableData = (existingItems, validatedItems) => {
    const existingItemsWithQtyValidation =
        existingItems?.length > 0 &&
        getItemTableDataWithQtyValidation(existingItems);

    let ListDetails =
        existingItemsWithQtyValidation?.length > 0
            ? existingItemsWithQtyValidation
            : existingItems;

    return (
        existingItemsWithQtyValidation?.length > 0
            ? existingItemsWithQtyValidation
            : existingItems
    ).map((obj, itemIdx) => {
        // let lotSerialIndex = '';
        // lotSerialIndex = ListDetails.map((item, index) =>
        //     item.lotSerial[0].Serial == obj.lotSerial[0].Serial ? index : null
        // ).filter((item) => item >= 0 && item != null);
        const firstSerial = obj.lotSerial?.[0]?.Serial;
        const lotSerialData = firstSerial
            ? ListDetails.map((item, index) =>
                  item.lotSerial?.[0]?.Serial === firstSerial ? index : null
              ).filter((item) => item != null)
            : [];

        const isMultipleSameItem =
            validatedItems.filter((v) => obj.cfn === v.productCFN)?.length > 1;

        const validatedProduct =
            validatedItems.filter(
                (val, vIdx) =>
                    obj.cfn === val.productCFN &&
                    (isMultipleSameItem ? itemIdx === vIdx : true)
            ) &&
            validatedItems.filter(
                (val, vIdx) =>
                    obj.cfn === val.productCFN &&
                    (isMultipleSameItem ? itemIdx === vIdx : true)
            )[0];
        const isInvalidUnidItemQuantity =
            validatedProduct?.isUnidRodItem &&
            validatedProduct?.statusMessage ===
                'Entered quantity exceeds the delivered quantity';

        const isLotSerialReqd =
            validatedProduct &&
            Object.prototype.hasOwnProperty.call(
                validatedProduct,
                'lotSerialData'
            );

        const validatedLotSerialArr =
            isLotSerialReqd &&
            Array.isArray(validatedProduct?.lotSerialData)
                ? validatedProduct.lotSerialData
                : [];
        const updatedLotSerialArr = isLotSerialReqd
            ? obj.lotSerial.map((x) =>
                  validatedLotSerialArr.find(
                      (vLot) =>
                          x.Serial &&
                          x.Serial.length > 0 &&
                          vLot.lotSerialNumber === x.Serial &&
                          vLot.statusCode === '10712'
                  )
                      ? {
                            ...x,
                            isInvalidLotSerialMsg: t(
                                'productValidationMessages.invalidLotNumber'
                            ),
                        }
                      : validatedLotSerialArr.find(
                            (vLot) =>
                                x.Serial &&
                                x.Serial.length > 0 &&
                                vLot.lotSerialNumber === x.Serial &&
                                vLot.statusCode === '200' &&
                                vLot.quantity &&
                                vLot.quantity.statusCode === '10826'
                        )
                      ? {
                            ...x,
                            isInvalidLotSerialMsg: '',
                            isInvalidQtyMsg: t(
                                'consignmentReturn.utils.quantityCantExceedsOnhandQuantity'
                            ),
                        }
                      : validatedLotSerialArr.find(
                            (vLot) => vLot.statusCode === '10816'
                        )
                      ? {
                            ...x,
                            isInvalidItemMsg: validatedLotSerialArr.find(
                                (vLot) => vLot.statusCode === '10816'
                            ).message,
                        }
                      : validatedLotSerialArr.find(
                            (vLot) =>
                                (!x.Serial ||
                                    (x.Serial && x.Serial.length === 0)) &&
                                vLot.statusCode === '10712'
                        )
                      ? {
                            ...x,
                            isInvalidLotSerialMsg: t(
                                'productValidationMessages.invalidLotNumber'
                            ),
                        }
                      : ListDetails.map((item, itemIndex) =>
                            item.lotSerial.filter(
                                (lotSerialItem) =>
                                    lotSerialItem.Serial === firstSerial
                            ) &&
                            lotSerialData.slice(1).includes(itemIdx) &&
                            lotSerialData.length > 1
                                ? itemIndex
                                : null
                        ).filter((item) => item >= 0 && item != null).length
                      ? {
                            ...x,
                            isInvalidLotSerialMsg: t(
                                'productValidationMessages.duplicateLotNumber'
                            ),
                        }
                      : validatedLotSerialArr.find(
                            (vLot) => vLot.statusCode === '10791'
                        )
                      ? {
                            ...x,
                            isInvalidItemMsg: t(
                                'productValidationMessages.ProductissueCare'
                            ),
                        }
                      : { ...x, isInvalidLotSerialMsg: null }
              )
            : obj.lotSerial.map((x) => {
                  //   let totalUnidQty, unidDeliveredQty;
                  //   if (obj.isUnidRodItem && obj.batchQtyObjArr?.length > 0) {
                  //       const batchQtyObj = obj.batchQtyObjArr.filter(
                  //           (b) => b.batch === x.Serial && b.deliveredQty
                  //       );
                  //       if (batchQtyObj && batchQtyObj[0]) {
                  //           unidDeliveredQty = batchQtyObj[0].deliveredQty;
                  //       }
                  //       const usedQty =
                  //           isNaN(x.used) || !x.used ? 0 : parseInt(x.used);
                  //       const otherQty =
                  //           isNaN(x.other) || !x.other ? 0 : parseInt(x.other);
                  //       totalUnidQty = usedQty + otherQty;
                  //   }
                  return {
                      ...x,
                      selectedBatchValue: isInvalidUnidItemQuantity
                          ? x.Serial
                          : null,
                      isInvalidQtyMsg:
                          //   totalUnidQty &&
                          //   unidDeliveredQty &&
                          //   totalUnidQty > parseInt(unidDeliveredQty)
                          isInvalidUnidItemQuantity
                              ? invalidUnidRodItemQtyMsg
                              : x.isInvalidQtyMsg,
                      isInvalidLotSerialMsg: null,
                  };
              });
        const validatedItemObj = {
            ...obj,
            isInvalidItemMsg:
                updatedLotSerialArr &&
                updatedLotSerialArr?.some((item) => item?.isInvalidItemMsg)
                    ? updatedLotSerialArr?.find(
                          (item) => item?.isInvalidItemMsg
                      )?.isInvalidItemMsg
                    : validatedProduct.statusCode === '10816'
                    ? validatedProduct.statusMessage
                    : null,
            isLotSerialReqd: isLotSerialReqd,
            lotSerial: updatedLotSerialArr,
            isInvalidUnidItemQuantity,
        };
        if (validatedProduct && validatedProduct.isUnidRodItem) {
            validatedItemObj.isUnidRodItem = validatedProduct.isUnidRodItem;
        }
        if (obj.isBundleItem && obj.children && obj.children.length > 0) {
            const updatedChildrenArr = getValidatedBundleChildren(
                existingItemsWithQtyValidation?.length > 0
                    ? existingItemsWithQtyValidation
                    : existingItems,
                obj.children,
                validatedItems
            );
            validatedItemObj.children = updatedChildrenArr;
        }
        return validatedItemObj;
    });
};

export const getValidReplenishGridData = (productsList) => {
    const replenItems = [];
    let nonTissueItems = productsList.filter(
        (x) => x.salesOrg === 'S002' && !x.isBundleItem
    );
    const bundleItems = productsList.filter(
        (item) => item.isBundleItem && item.children && item.children.length > 0
    );
    const bundleChildren =
        bundleItems && bundleItems.length > 0
            ? bundleItems
                  .reduce((prev, curr) => prev.concat(curr.children), [])
                  .filter((x) => x.salesOrg === 'S002')
            : [];
    nonTissueItems = nonTissueItems.concat(bundleChildren);
    if (nonTissueItems.length > 0) {
        nonTissueItems.forEach((item) => {
            if (!replenItems.map((x) => x.cfn).includes(item.cfn)) {
                replenItems.push({
                    ...item,
                    isSelected: false,
                    replenQty: getTotalQuantity(item.lotSerial),
                });
            } else {
                const itemIdx = replenItems.findIndex(
                    (x) => x.cfn === item.cfn
                );
                if (itemIdx >= 0) {
                    replenItems[itemIdx].replenQty = getTotalQuantity([
                        ...replenItems[itemIdx].lotSerial,
                        ...item.lotSerial,
                    ]);
                }
            }
        });
    }
    return replenItems;
};

export const getPriceOverrideTableData = (itemTableData) => {
    const tissueItems = itemTableData.filter(
        (item) => item.salesOrg === 'S030' && !item.accountOwned
    );
    const nonTissueItems = itemTableData.filter(
        (item) => item.salesOrg === 'S002' && !item.accountOwned
    );
    return [...tissueItems, ...nonTissueItems];
};

export const getUpdatedPriceOverridenData = (
    existingTableData,
    priceOverridenData
) => {
    return existingTableData.map((existingItem) => {
        let updatedItemObj = { ...existingItem };
        const priceOverwrittenItemIdx = priceOverridenData
            .map((x) => x.cfn)
            .findIndex((y) => y === existingItem.cfn);
        if (priceOverwrittenItemIdx >= 0) {
            updatedItemObj = {
                ...priceOverridenData[priceOverwrittenItemIdx],
            };
        }
        return updatedItemObj;
    });
};
